
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/finance-glossary/[glossary]",
      function () {
        return require("private-next-pages/finance-glossary/[glossary].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/finance-glossary/[glossary]"])
      });
    }
  